<template >
  <div class="_promobookingheader">
    <div class="row __wrapper_">
      <div class="_promobooking_back" @click="goBack">
          <img src="@/assets/image/icon/left-arrow-blue.svg" alt="">
          <span>Back</span>
      </div>
      <div class="d-flex flex-row _infoheader__content justify-content-center align-items-center">
          <img class="__cargoBox" src="@/assets/image/instantprice/AIR CARGO BOX.svg" alt="">
          <div class="__fromTo">
            <p class="__aircargo">Air Cargo</p>
            <p class="__city">Bandung to Perth</p>
            <p class="__via">Door to Port</p>
            <p class="__periods">Promo Periods:  07 - 15 March 2019</p>
            <p class="__promoTitle">Promo Booking Form</p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bookingheader',
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promo/PromoBookingHeader.vue